<template>
<div class="p-fluid">
    <div class="p-col-12 p-lg-12">
<div class="card card-w-title">
  <div class="p-formgrid">
    <div class="group-permission-title p-grid">
      <div v-if="this.mode == 'add'">Thêm thông báo</div>
      <div v-else>Chỉnh sửa bảng giá cơ quan</div>
      <Toolbar class="fixed-bottom-toolbar" style="flex: auto;">
      <template slot="right">
        <Button
          label="Quay lại"
          @click="backToList()"
          class="p-button-warning"
        />
        <Button
          v-if="mode == 'edit'"
          :label="'Lưu thay đổi'"
          @click="saveData()"
          class="p-button-success"
        />
        <Button
          v-else
          :label="'Thêm mới'"
          @click="saveData()"
          class="p-button-success"
        />
      </template>
    </Toolbar>
    </div>
      <div class="card card-w-body">
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Tiêu đề*</label>
            <div class="p-col-8">
              <InputText id="title" v-model="title" placeholder="Nhập tiêu đề thông báo"/> 
              <small
                v-if="validationErrors && validationErrors['title']"
                class="p-invalid"
              >{{validationErrors['title']}}</small>
            </div>
          </div>
          <div class="p-col-2">
          </div>
          <div class="p-col-5 p-grid">
            <label class="p-col-4 txt-left">Mã nhân viên*</label>
            <div class="p-col-8">
              <MultiSelect v-model="selectedUser" :options="this.list_user" 
              optionLabel="code" placeholder="Chọn mã nhân viên" :filter="true">
              </MultiSelect>
              <small
                v-if="validationErrors && validationErrors['user_id']"
                class="p-invalid"
              >{{validationErrors['user_id']}}</small>
            </div>
          </div>
        </div>
        <div class="p-field p-grid" style="padding-top: 15px;">
          <div class="p-col-12 p-grid">
            <label class="p-col-3 txt-left">Nội dung*</label>
            <div class="p-col-9 p-grid" >
              <Editor v-model="content" editorStyle="height: 320px;"/>
              <small
                v-if="validationErrors && validationErrors['content']"
                class="p-invalid"
              >{{validationErrors['content']}}</small>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
    </div>
</div>
</template>

<script>
// import DataServices from '@/core/DataServices'
// import moment from "moment-timezone";
import stripHtml from "string-strip-html";
import gql from "graphql-tag";
export default {
  props: {
    mode: String,
    model: Object,
  },
  data() {
    return {
      validationErrors: {},
      formMode: this.mode,
      title: '',
      list_user: [],
      selectedUser: [],
      content: ''
    }
  },
  mounted() {
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      var has_error = false
      if (this.mode == 'add') {
        if (this.title == '') {
          this.validationErrors['title'] = 'Nhập tiêu đề thông báo';
          has_error = true
        }
        if (this.selectedUser.length == 0) {
          this.validationErrors['user_id'] = 'Vui lòng chọn mã nhân viên';
          has_error = true
        }
        if (this.content == '') {
          this.validationErrors['content'] = 'Nhập nội dung thông báo';
          has_error = true
        }
      }
      return has_error
    },
    async analyzeData() {
      var data_notification = {}
        data_notification['title'] = this.title
        data_notification['content'] = this.content
        data_notification['is_push'] = true
        // console.log("this.selectedUser.length", this.selectedUser.length)
        // console.log("this.list_user", this.list_user)
        if (this.selectedUser.length == this.list_user.length) {
          data_notification['receiver'] = 1
        }
      return data_notification
    },
    async saveData() {
      if (await this.validateData()) {
        // console.log('true')
        return;
      }
      console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
      if (this.mode == 'add') {
        // this.$store.commit("setLoading", true);
        let list_id = [];
        let noti_user = []
        var data_notification = await this.analyzeData()

        var query = `mutation MyMutation($objects: [notification_insert_input!]!) {
            insert_notification(objects: $objects) {
              affected_rows
              returning {
                id
              }
            }
          }`;
        console.log("query", query);
        await this.$apollo
          .mutate({
            mutation: gql(query),
            variables: {
              objects: data_notification
            }
          })
          .then(async (res) => {
            if (res.data[Object.keys(res.data)[0]].affected_rows > 0) {
              var notification_id = res.data.insert_notification.returning[0].id
              var content_html = stripHtml(this.content).result
              var title_push = this.title

              for (let i = 0; i < this.selectedUser.length; i++) {
                const el = this.selectedUser[i];
                let tmp_noti_user = {
                  notification_id : notification_id,
                  uid : el.id,
                  is_push: true,

                }
                noti_user.push(tmp_noti_user)
                list_id.push(`"${el.id}"`)
              }
              var query_insert_noti_user = `mutation MyMutation($objects: [notification_users_insert_input!]!){
                insert_notification_users(
                  objects: $objects
                ) {
                  affected_rows
                }
              }`
              this.$apollo
                .mutate({
                  mutation: gql(query_insert_noti_user),
                  variables: {
                    objects: noti_user
                  }
                })
                .then( async(res) => {
                  console.log("chạy xong",res);
                  var query_devices = `query MyQuery {
                    users(where: {id: {_in: [${list_id}]}}) {
                      user_devices {
                        fcm_token
                      }
                      id
                    }
                  }`
                  this.$apollo.mutate({
                      mutation: gql(query_devices)
                  }).then(res => {
                      //console.log('ressssssssssssssssss', res)
                      var str_users2 = []
                      let users = res.data.users
                      for (let i = 0; i < users.length; i++) {
                        const u = users[i];
                        if (u.user_devices && u.user_devices != []){
                          for (let t = 0; t < u.user_devices.length; t++) {
                            const d = u.user_devices[t];
                            str_users2.push(`{token:"${d.fcm_token}",language:"vn"}`)
                          }
                        }
                      }
                      let query = `mutation MyMutation {
                        insert_notification_tmp(objects: {notification_id: ${notification_id}, content: "${content_html}", tokens: [${str_users2}], title: "${title_push}"}) {
                          affected_rows
                        }
                      }`
                      this.$apollo.mutate({
                        mutation: gql(query)
                      }).then(res => {
                        console.log('res', res)
                        this.$toast.add({
                          severity: "success",
                          summary: "Thành công",
                          detail: "Thêm thành công",
                          life: 3000
                        });
                        setTimeout(()=>
                          location.href = `/admin/list-notification`
                        , 1000);
                      })
                  })
                })
            } else {
              // this.$store.commit("setLoading", false);
              this.$toast.add({
                severity: "error",
                summary: "Thất bại",
                detail: "Lưu dữ liệu thất bại",
                life: 3000
              });
            }
          })
      }
    },
  },
  apollo: {
    user_dpv: {
      query() {
        let query = `
          query MyQuery {
            users(where: {deleted: {_eq: false}, users_account: {role: {_neq: "admin"}}}) {
              id
              code
              fullname
            }
          }
        `
        return gql(query);
      },
      update(data) {
        if(data.users){
          this.list_user = data.users
          // if (this.list_user.length > 0) {
          //   for (let i = 0; i < this.list_user.length; i++) {
          //     const e = this.list_user[i];
          //     e.code = e.code + ' - ' + e.fullname
          //   }
          // }
        }
      },
      fetchPolicy: "network-only",
    },
  }
}
</script>

<style lang="scss">
  .p-multiselect {
    width: 100%;
  }
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: .25rem;
    padding-bottom: .25rem;
    
  }
  .category-item-value {
    padding: .25rem .5rem;
    border-radius: 3px;
    display: inline-flex;
    margin-right: .2rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
  .p-multiselect-label-container{
    height: 40px;
  }
  .card.card-w-body {
    background-color: #FAFAFA;
    // padding: 1em;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  
  </style>
